import { axios } from '@/util/axios.js';
const baseUrl = '/api'
function handlerPaging(params={}){
    let {page,limit} = params;
    let pn = parseInt(page),ps = parseInt(limit);
    if(isNaN(pn) || pn < 0 ){
      pn = 1;
    }
    if(isNaN(ps) || ps < 1 ){
      ps = 10;
    }
    return Object.assign(params,{page:pn,limit:ps})
  }

/* 站点下告警列表 */
export function siteAlarmList(params = {}, callback) {
    handlerPaging(params.data);
    return axios.request({
      "url" : baseUrl+'/sites/'+params.site_id+"/alarm_info/",
        "method": "get",
        "params":params.data
    },callback)
}
  

/* 设备级报警列表 */
export function equipmentAlarmList(params = {}, callback) {
    handlerPaging(params.data);
    return axios.request({
      "url" : baseUrl+'/equipments/'+params.equipments_id+"/alarm_info/",
        "method": "get",
        "params": params.data
    },callback)
}

/* 公司级测点报警统计 */
export function customerAlarmStat(params = {}, callback) {
    return axios.request({
      "url" : baseUrl+'/customers/'+params.customer_id+"/alarm_stat/",
        "method": "get",
        "params": params.data
    },callback)
}

/* 站点级测点报警统计 */
export function siteAlarmStat(params = {}, callback) {
    return axios.request({
      "url" : baseUrl+'/sites/'+params.site_id+"/alarm_stat/",
        "method": "get",
        "params": params.data
    },callback)
}

/* 设备级测点报警统计 */
export function equipmentAlarmStat(params = {}, callback) {
    return axios.request({
      "url" : baseUrl+'/equipments/'+params.equipment_id+"/alarm_stat/",
        "method": "get",
        "params": params.data
    },callback)
}

/* 公司下告警列表 */
export function customerAlarmList(params = {}, callback) {
    handlerPaging(params.data);
    return axios.request({
      "url" : baseUrl+'/customers/'+params.customer_id+"/alarm_info/",
        "method": "get",
        "params":params.data
    },callback)
}


/* 处理告警 */
export function handleAlarm(params = {}, callback) {
    return axios.request({
      "url" : baseUrl+'/alarms/'+params.alarm_id+"/",
        "method": "put",
        "data":params.data
    },callback)
}

/* 获取趋势报警数据 */
export function getTrendAlarmDataList(params = {}, callback) {
    return axios.request({
      "url" : baseUrl+'/trend_alarm_details/'+params.trend_alarm_id+"/",
      "method": "get",
    },callback)
}

/* 导出报警数据 */
export function exportAlarmData(params = {}, callback) {
    return axios.request({
      "url" : baseUrl+'/alarm_export/'+params.customer_id+"/",
      "method": "post",
      "data":params.data,
      "responseType": 'blob'
    },callback)
}

/* 公司级测点报警统计导出 */
export function customerAlarmStatExport(params = {}, callback) {
    return axios.request({
      "url" : baseUrl+'/customers/'+params.customer_id+'/alarm_stat_export/',
      "method": "post",
      "data": params.data,
      "responseType": 'blob'
    },callback)
}

/* 站点级测点报警统计导出 */
export function siteAlarmStatExport(params = {}, callback) {
    return axios.request({
      "url" : baseUrl+'/sites/'+params.site_id+'/alarm_stat_export/',
      "method": "post",
      "data": params.data,
      "responseType": 'blob'
    },callback)
}

/* 设备级测点报警统计导出 */
export function equipmentAlarmStatExport(params = {}, callback) {
    return axios.request({
      "url" : baseUrl+'/equipments/'+params.equipment_id+'/alarm_stat_export/',
      "method": "post",
      "data": params.data,
      "responseType": 'blob'
    },callback)
}

/* 传感器自检状态列表 */
export function selfCheckStatusList(params = {}, callback) {
    handlerPaging(params.data);
    return axios.request({
      "url" : baseUrl+'/self_check_status/',
        "method": "get",
        "params": params.data
    },callback)
}





// WEBPACK FOOTER //
// ./src/data/warning.js